export default __webpack_public_path__ + "static/media/stuck-veskovic-modernes-badezimmer-3.fb43277a.jpg";